<template>
	<div>
		<div class="control-item">
			<button v-on:click="selectAll" type="button">全部选中</button>
		</div>
		<template v-if="isQA">
			<div class="control-item">
				<button v-on:click="eligible" type="button">好品(G)</button>
			</div>
			<div class="control-item">
				<button v-on:click="ineligible" type="button">坏品(B)</button>
			</div>
		</template>
		<template v-else>
			<div class="control-item" style="margin-bottom:20px;">
				当前角色无操作权限。
			</div>
		</template>
		<div class="control-item">
			<label for>缺陷类型：</label>
			<select v-model="type">
				<option :value="-1">全部</option>
				<option v-for="item in defectTypes" v-bind:key="item.value" :value="item.value" :label="item.label"></option>
			</select>
		</div>
		<div class="control-item">
			<label for>缺陷状态：</label>
			<select v-model="status">
				<option v-for="item in statelist" v-bind:key="item.value" :value="item.value" :label="item.text"></option>
			</select>
		</div>
		<div class="control-item">
			<label for>检测面：</label>
			<select v-model="surface">
				<option v-for="item in surfacelist" v-bind:key="item.value" :value="item.value" :label="item.text"></option>
			</select>
		</div>
		<div class="control-item">
			<p>
				<label for="">好品：<span v-text="goodCount"></span></label>
			</p>
			<p>
				<label for="">坏品：<span v-text="badCount">0</span></label>
			</p>
		</div>
		<div class="control-item">
			<button v-on:click="changeFilterStatus" type="button" v-text="filterStatusText"></button>
		</div>
		<div class="control-item">
			<a href="#" @click="dialogVisible = true" style="color:#aaa;">快捷键提示</a>
		</div>
		<div class="remark_box">
			<label for="browser_show_remark">
				<input id="browser_show_remark" type="checkbox" v-model="checkedValue" />
				查标记码
			</label>
			<textarea v-model="checkMark" placeholder="请输入查询内容" style="width:112px; margin-top:5px;" rows="10"> </textarea>
		</div>

		<el-dialog title="快捷键提示" :visible.sync="dialogVisible" width="350px">
			<div class="shortcut">
				<ul>
					<li>
						<label for="">向下移动快捷键：</label>
						<span>↓</span>
					</li>
					<li>
						<label for="">向上移动快捷键：</label>
						<span>↑</span>
					</li>
					<li>
						<label for="">好品：</label>
						<span>G</span>
					</li>
					<li>
						<label for="">坏品：</label>
						<span>B</span>
					</li>
				</ul>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { store } from './store'
	export default {
		data() {
			return {
				type: -1,
				status: '',
				surface: 0,
				checked: false,
				dialogVisible: false,
				checkMark: '',
				checkedValue: false,
				statelist: [
					{
						value: '',
						text: '全部',
					},
					{
						value: 'good',
						text: '好品',
					},
					{
						value: 'bad',
						text: '坏品',
					},
				],

				/**
				 * 好品数量。
				 */
				goodCount: 0,

				/**
				 * 坏品数量。
				 */
				badCount: 0,
				/**
				 * 筛选状态文本。
				 */
				filterStatusText: '',
			}
		},
		computed: {
			/**
			 * 缺陷记录，用来进行监控。
			 */
			filteredDefects() {
				return store.state.filteredDefects
			},
			/**
			 * 所有缺陷类型。
			 */
			defectTypes() {
				var list = []
				var types = store.state.defectTypes
				if (types.length > 0) {
					types.forEach((v, i) => {
						var count = store.state.defects.filter(t => t.type_index == v.type_index).length
						if (count > 0) {
							if (list.findIndex(t => t.name == v.name) == -1) {
								list.push({
									label: v.display,
									value: v.type_index,
								})
							}
						}
					})
				}
				return list
			},
			/**
			 * 所有版面。
			 */
			modelSides() {
				return store.state.modelSides
			},
			/**
			 * 版面集合下拉框数据集。
			 */
			surfacelist() {
				var list = [
					{
						value: -1,
						text: '全部',
					},
				]

				if (this.modelSides) {
					this.modelSides.forEach((v, i) => {
						list.push({
							value: v.side_index,
							text: v.name,
						})
					})
				}
				return list.sort((a, b) => {
					return a.value - b.value
				})
			},
			/**
			 * 筛选状态。
			 */
			filterStatus() {
				return store.state.filterStatus
			},
			/**
			 * 是否是质检。
			 */
			isQA() {
				return store.state.isQA
			},
		},
		watch: {
			/**
			 * 监控缺陷记录，实时显示好品和坏品数量。
			 */
			filteredDefects: {
				handler(array) {
					this.badCount = array.filter(t => t.status == 0).length
					this.goodCount = array.filter(t => t.status == 1).length

					console.log('好品数量：{0},坏品数量:{1}', this.goodCount, this.badCount)
				},
				deep: true,
			},
			/**
			 * 根据标记进行过滤。
			 */
			checkMark(val) {
				store.setFilter({
					checkMark: val,
					markValue: this.checkedValue,
				})
			},
			/**
			 * 是否进行标记过滤。
			 */
			checkedValue(val) {
				store.setFilter({
					checkMark: this.checkMark,
					markValue: val,
				})
			},
			/**
			 * 监控缺陷类型选择。
			 */
			type(val) {
				store.setFilter({
					type: val,
				})
			},
			/**
			 * 监控缺陷状态选择。
			 */
			status(val) {
				store.setFilter({
					status: val,
				})
			},
			/**
			 * 监控检测面，设置默认检测面。
			 */
			surfacelist(val) {
				if (val.length > 0) {
					if (val.length > 0) {
						this.surface = val[0].value
					}
				}
			},
			/**
			 * 监控设置检测面，修改过滤条件并且设置版面图索引。
			 */
			surface(val) {
				//设置按版面图进行筛选。
				store.setFilter({
					side_index: val,
				})

				//设置版面图索引。
				store.setModelSideIndex(val)
			},
			/**
			 * 设置筛选状态文本。
			 */
			filterStatus(val) {
				var text = store.getFilterStatusText(val)
				this.filterStatusText = text
			},
		},
		methods: {
			/**
			 * 全部选中。
			 */
			selectAll() {
				this.checked = !this.checked
				store.setDefectsSelected(this.checked)
			},
			/**
			 * 好品。
			 */
			eligible() {
				store.setDefectsStatus(1)
			},
			/**
			 * 坏品。
			 */
			ineligible() {
				store.setDefectsStatus(0)
			},
			/**
			 * 修改筛选状态。
			 */
			changeFilterStatus() {
				var current_status = store.state.batchInfo.filter_status ?? 0
				var status = current_status
				if (current_status == 1) {
					status = 2
				}

				store.changeFilterStatus(status)
			},
		},
		created() {
			this.filterStatusText = store.getFilterStatusText(this.filterStatus)
		},
	}
</script>

<style lang="less" scoped>
	.control-item {
		margin-bottom: 5px;
		button {
			width: 100%;
			background-color: #d2d2d2;
			border: 1px #636363 solid;
			padding: 5px;
			font-size: 12px;
		}

		button:active {
			background-color: #aaa;
		}

		label {
			display: block;
			color: #000;
		}

		select {
			width: 100%;
			padding: 5px;
		}
	}

	.shortcut {
		ul {
			margin: 0;
			padding: 0;

			li {
				list-style: none;
				font-size: 12px;
				color: #aaa;
				padding: 5px 0;

				label {
					display: inline-block;
					width: 130px;
					text-align: right;
				}

				span {
					background-color: #aaa;
					display: inline-block;
					width: 24px;
					height: 24px;
					color: #fff;
					text-align: center;
					border-radius: 3px;
					line-height: 24px;
				}
			}
		}
	}

	.outer {
		height: 100%;
		margin: 0;
		padding: 0;
	}

	.remark_box {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 10px;
	}
</style>
